/**
 * Error Page Component
 * Created: 2024-11-12
 *
 * This component handles errors that occur during rendering.
 * It's a client component that displays a friendly error message.
 */

'use client'

import {useEffect} from 'react'
import Link from 'next/link'

export default function Error({error, reset}: {error: Error & {digest?: string}; reset: () => void}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Error caught:', error)
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong!</h1>
        <p className="mb-4 text-gray-700">We're sorry, but an unexpected error has occurred.</p>
        <div className="flex flex-col space-y-4">
          <button onClick={reset} className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
            Try again
          </button>
          <Link href="/" className="w-full py-2 px-4 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors text-center">
            Return Home
          </Link>
        </div>
      </div>
    </div>
  )
}
